





















































import { Component, Prop, Vue } from 'vue-property-decorator';

import Swal from 'sweetalert2';

import SingleThreat from './SingleThreat.vue';

import {
  AssessmentInstance,
  AssessmentInstanceThreat,
  Section,
  ThreatResponse,
  ThreatWithQuestions,
} from '../models';

import {
  httpPost,
} from '../utils';

@Component({
  components: {
    SingleThreat,
  },
})
export default class ThreatList extends Vue {
  @Prop(Object) private readonly assessment!: AssessmentInstance;

  private isLoading: boolean = false;
  private showOtherThreats: boolean = false;

  get assessmentId(): number {
    return parseInt(this.$route.params.assessmentId, 10);
  }

  get sectionId(): number {
    return parseInt(this.$route.params.sectionId, 10);
  }

  get section(): Section {
    return this.assessment.sections.find((s) => s.id === this.sectionId)!;
  }

  get sortedSections(): Section[] {
    return this.assessment.sections.sort((s1, s2) => s1.sortOrder - s2.sortOrder);
  }

  get nextSectionIndex(): number {
    const currentSectionIndex = this.sortedSections.findIndex((s) => s.id === this.sectionId);
    if (currentSectionIndex + 1 === this.sortedSections.length) {
      return -1;
    } else {
      return currentSectionIndex + 1;
    }
  }

  get identifiedThreats(): ThreatWithQuestions[] {
    return this.section.threats!.filter((t) => t.questions.length > 0);
  }

  get otherThreats(): ThreatWithQuestions[] {
    return this.section.threats!.filter((t) => t.questions.length === 0);
  }

  get otherThreatsButtonText(): string {
    return this.showOtherThreats ? 'Hide Threats' : 'Show Threats';
  }

  private saveThreats(continueToNextSection: boolean = false) {
    const url = `${process.env.VUE_APP_API_HOST}/assessments/${this.assessmentId}/sections/${this.sectionId}/threats`;
    const data = this.createThreatResponses();
    this.isLoading = true;
    httpPost<AssessmentInstanceThreat[]>(url, data)
      .then(() => {
        Swal.fire({
          title: 'Save Successful',
          type: 'success',
        });
      }).catch((error) => {
        Swal.fire({
          title: 'Save Failed',
          text: `Error: ${error.message}`,
          type: 'error',
        });
      }).then(() => {
        this.isLoading = false;
        if (continueToNextSection) {
          if (this.nextSectionIndex === -1) {
            this.$router.push({
              name: 'summary',
              params: {
                assessmentId: `${this.assessmentId}`,
              },
            });
          } else {
            const nextSection = this.sortedSections[this.nextSectionIndex];
            this.$router.push({
              name: 'threats-section',
              params: {
                sectionId: `${nextSection.id}`,
              },
            });
          }
        }
      });
  }

  private createThreatResponses(): ThreatResponse[] {
    return this.section.threats!.map((t) => {
      return {
        threatId: t.assessmentInstanceThreat.threat.id,
        likelihood: t.assessmentInstanceThreat.likelihood,
        impact: t.assessmentInstanceThreat.impact,
        isApplicable: t.assessmentInstanceThreat.isApplicable,
      };
    });
  }
}
